import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import useAuthStore from '../../store/authStore';
import toast from 'react-hot-toast';

export default function PatientDashboard() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/appointments').then(res => {
      setAppointments(res.data.data || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleLogout = async () => {
    try { await api.post('/auth/logout'); } catch(e) {}
    logout();
    navigate('/login');
  };

  const statusColor = (s) => ({
    pending:'bg-yellow-100 text-yellow-700',
    confirmed:'bg-green-100 text-green-700',
    cancelled:'bg-red-100 text-red-700',
    completed:'bg-blue-100 text-blue-700',
  }[s] || 'bg-gray-100 text-gray-700');

  const statusLabel = (s) => ({
    pending:'En attente', confirmed:'Confirmé',
    cancelled:'Annulé', completed:'Terminé'
  }[s] || s);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-100 px-4 py-3 flex items-center justify-between sticky top-0 z-10">
        <div className="flex items-center gap-2">
          <span className="text-2xl">🏥</span>
          <span className="font-bold text-green-700">SantéTogo</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-gray-600">Bonjour, {user?.name?.split(' ')[0]}</span>
          <button onClick={handleLogout} className="text-sm text-red-500 hover:text-red-700">Déconnexion</button>
        </div>
      </div>

      <div className="max-w-lg mx-auto p-4 space-y-4">
        {/* Actions rapides */}
        <div className="grid grid-cols-2 gap-3 mt-2">
          <Link to="/doctors" className="card flex flex-col items-center py-5 hover:border-green-300 hover:shadow-md transition-all">
            <span className="text-3xl mb-2">🔍</span>
            <span className="font-semibold text-gray-700 text-sm">Trouver un médecin</span>
          </Link>
          <Link to="/patient/appointments" className="card flex flex-col items-center py-5 hover:border-green-300 hover:shadow-md transition-all">
            <span className="text-3xl mb-2">📅</span>
            <span className="font-semibold text-gray-700 text-sm">Mes rendez-vous</span>
          </Link>
          <Link to="/patient/records" className="card flex flex-col items-center py-5 hover:border-green-300 hover:shadow-md transition-all">
            <span className="text-3xl mb-2">📋</span>
            <span className="font-semibold text-gray-700 text-sm">Dossier médical</span>
          </Link>
          <Link to="/patient/profile" className="card flex flex-col items-center py-5 hover:border-green-300 hover:shadow-md transition-all">
            <span className="text-3xl mb-2">👤</span>
            <span className="font-semibold text-gray-700 text-sm">Mon profil</span>
          </Link>
        </div>

        {/* Prochains RDV */}
        <div className="card">
          <h3 className="font-bold text-gray-800 mb-3">Prochains rendez-vous</h3>
          {loading ? (
            <p className="text-gray-400 text-sm text-center py-4">Chargement...</p>
          ) : appointments.length === 0 ? (
            <div className="text-center py-6">
              <p className="text-gray-400 text-sm mb-3">Aucun rendez-vous</p>
              <Link to="/doctors" className="btn-primary text-sm px-4 py-2">Prendre un RDV</Link>
            </div>
          ) : (
            <div className="space-y-3">
              {appointments.slice(0,3).map(apt => (
                <div key={apt.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                  <div>
                    <p className="font-semibold text-sm">{apt.doctor?.user?.name}</p>
                    <p className="text-xs text-gray-500">{apt.doctor?.specialty?.name_fr}</p>
                    <p className="text-xs text-gray-500">{new Date(apt.scheduled_at).toLocaleDateString('fr-FR', {day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}</p>
                  </div>
                  <span className={`text-xs px-2 py-1 rounded-full font-medium ${statusColor(apt.status)}`}>
                    {statusLabel(apt.status)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
